import { useState } from "react";
import { Info } from "@acto/web-common/components";
import { useTranslations } from "@acto/web-common/locales";
import { CustomerRouteSegments } from "@acto/taskpane/core/router/routes.config";
import { useNavigateWithReturn } from "@acto/taskpane/field-sales-2/navigation";
import { ActionPillButton, ActionPillMenuButton } from "@acto/taskpane/field-sales-2/components/primitives/ActionPill";
import { HeaderActionPill } from "@acto/taskpane/field-sales-2/components/primitives/HeaderActionPill";
import { KebabIcon } from "@acto/taskpane/field-sales-2/components/primitives/KebabIcon";
import { CustomerActionsSheetHost } from "./CustomerActionsSheetHost";

interface CustomerActionsPillProps {
  clientId: string;
  className?: string;
  customerName?: string;
}

export function CustomerActionsPill({ className, clientId, customerName }: CustomerActionsPillProps) {
  const t = useTranslations("fieldSalesTwo.customerActions");
  const push = useNavigateWithReturn();
  const [sheetOpen, setSheetOpen] = useState(false);

  const handleInfoClick = () => push(CustomerRouteSegments.INFO);

  return (
    <>
      <HeaderActionPill variant="action" className={className}>
        <ActionPillButton aria-label={t("infoAriaLabel")} onClick={handleInfoClick}>
          <Info />
        </ActionPillButton>
        <ActionPillMenuButton
          aria-label={t("openMenuAriaLabel")}
          aria-haspopup="dialog"
          aria-expanded={sheetOpen}
          onClick={() => setSheetOpen(true)}
        >
          <KebabIcon />
        </ActionPillMenuButton>
      </HeaderActionPill>
      <CustomerActionsSheetHost
        clientId={clientId}
        isOpen={sheetOpen}
        onOpenChange={setSheetOpen}
        customerName={customerName}
      />
    </>
  );
}
